"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemCustomRubricSerializer = void 0;
var item_custom_rubric_model_1 = require("../../models/item-custom-rubric.model");
var ItemCustomRubricSerializer = /** @class */ (function () {
    function ItemCustomRubricSerializer(customRubricSerializer) {
        this.customRubricSerializer = customRubricSerializer;
    }
    ItemCustomRubricSerializer.prototype.serialize = function (itemCustomRubric) {
        return new item_custom_rubric_model_1.ItemCustomRubric({
            id: itemCustomRubric.id,
            externalItemId: itemCustomRubric.externalItemId,
            externalQuestionId: itemCustomRubric.externalQuestionId,
            customRubric: this.customRubricSerializer.serialize(itemCustomRubric.customRubric),
        });
    };
    return ItemCustomRubricSerializer;
}());
exports.ItemCustomRubricSerializer = ItemCustomRubricSerializer;
